var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.authUserID && _vm.profilePP)?_c('div',{attrs:{"id":"mobile-header"}},[(
      _vm.profilePP.basic && _vm.profilePP.basic.photo && _vm.profilePP.basic.photo.value
    )?_c('img',{staticClass:"mobile-header-photo",attrs:{"src":_vm.profilePP.basic.photo.value,"alt":"Profile Image"}}):_vm._e(),(
      _vm.profilePP.blog && _vm.profilePP.blog.pos_A && _vm.profilePP.blog.pos_A.value
    )?_c('span',{staticClass:"my-2 d-block",style:(_vm.getStyle(_vm.profilePP.blog.pos_A))},[_vm._v(_vm._s(_vm.profilePP.blog.pos_A.value))]):_vm._e(),(
      _vm.profilePP.blog && _vm.profilePP.blog.pos_B && _vm.profilePP.blog.pos_B.value
    )?_c('span',{staticClass:"my-2 d-block",style:(_vm.getStyle(_vm.profilePP.blog.pos_B))},[_vm._v(_vm._s(_vm.profilePP.blog.pos_B.value))]):_vm._e(),_c('div',[(
        _vm.profilePP.basic &&
        _vm.profilePP.basic.phone &&
        _vm.profilePP.basic.phone.value
      )?_c('a',{staticClass:"my-3 mx-1 phone",attrs:{"href":_vm.phoneLink,"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"fa-lg",attrs:{"icon":"fa-solid fa-phone-volume"}})],1):_vm._e(),(
        _vm.profilePP.blog &&
        _vm.profilePP.blog.lead_email &&
        _vm.profilePP.blog.lead_email.value
      )?_c('a',{staticClass:"my-3 mx-1 mail",attrs:{"href":_vm.emailLink,"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"fa-lg",attrs:{"icon":"fa-regular fa-envelope"}})],1):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }